export type SceneTheme = "light" | "dark";

/** Etapas da obra que acompanham o fluxo de login; `blueprint` é a recuperação de conta. */
export type ScenePhase = "site" | "structure" | "facade" | "delivered" | "blueprint";

export interface SceneThemeTokens {
    skyTop: string;
    skyHorizon: string;
    skyBottom: string;
    fog: { color: string; near: number; far: number };
    asphalt: string;
    sidewalk: string;
    concrete: string;
    leafTint: string;
    line: string;
    lineRest: number;
    bloom: number;
    hemisphere: number;
    sun: { intensity: number; color: string; elevation: number; azimuth: number; turbidity: number; rayleigh: number };
    exposure: number;
    streetLamp: number;
    towerWindows: number;
    cityWindows: number;
    carLights: number;
    bird: string;
    vignette: number;
    envIntensity: number;
    sign: { off: number; on: number };
    plan: { bg: string; grid: string; ink: string; faint: string; text: string; accent: string };
}

/**
 * Valores por tema. As cores de marca seguem o tailwind.config (dark_green, green_on_dark,
 * yellow, night); o resto é iluminação da cena.
 */
export const SCENE_THEMES: Record<SceneTheme, SceneThemeTokens> = {
    dark: {
        skyTop: "#07100c",
        skyHorizon: "#1f3a30",
        skyBottom: "#0b130f",
        fog: { color: "#1a3028", near: 50, far: 170 },
        asphalt: "#20262a",
        sidewalk: "#4a524d",
        concrete: "#9aa19a",
        leafTint: "#ffffff",
        line: "#7DD590",
        lineRest: 0.12,
        bloom: 0.7,
        hemisphere: 0.3,
        sun: { intensity: 1.4, color: "#ffb978", elevation: 8, azimuth: -60, turbidity: 6, rayleigh: 2.5 },
        exposure: 1.05,
        streetLamp: 1.6,
        towerWindows: 3,
        cityWindows: 1.1,
        carLights: 3,
        bird: "#0d1210",
        vignette: 0.6,
        envIntensity: 0.55,
        sign: { off: 0.28, on: 0.78 },
        plan: {
            bg: "#0E1611",
            grid: "rgba(125,213,144,0.06)",
            ink: "#7DD590",
            faint: "rgba(125,213,144,0.42)",
            text: "#C0DD97",
            accent: "#FBBC04",
        },
    },
    light: {
        skyTop: "#b9cfd8",
        skyHorizon: "#e9ece6",
        skyBottom: "#e4e7e1",
        fog: { color: "#e3e7e1", near: 60, far: 190 },
        asphalt: "#c3c7c1",
        sidewalk: "#dcdfd8",
        concrete: "#d9dcd5",
        leafTint: "#d6e6cc",
        line: "#1A3C30",
        lineRest: 0.12,
        bloom: 0.12,
        hemisphere: 0.5,
        sun: { intensity: 2.2, color: "#fff4e2", elevation: 38, azimuth: -55, turbidity: 3, rayleigh: 1 },
        exposure: 0.9,
        streetLamp: 0,
        towerWindows: 0.6,
        cityWindows: 0,
        carLights: 0.4,
        bird: "#4a514c",
        vignette: 0.28,
        envIntensity: 1,
        sign: { off: 0.92, on: 0.92 },
        plan: {
            bg: "#F3F4EF",
            grid: "rgba(26,60,48,0.06)",
            ink: "#1A3C30",
            faint: "rgba(26,60,48,0.4)",
            text: "#2C5A47",
            accent: "#A87400",
        },
    },
};
